// extracted by mini-css-extract-plugin
module.exports = {"notEditing":"EditorInput_notEditing__2EQ5B","multiLine":"EditorInput_multiLine__2V6ed","empty":"EditorInput_empty__25Bc3"};